<!-- Authentication form container -->
<ng-container>
  <form #authForm="ngForm" (submit)="onSubmit(authForm)">
    <!-- Dynamic form fields rendered from configuration -->
    @for (field of config()?.fields; track $index) {
    <ng-container>
      <!-- Fields flagged as hidden stay mounted (not *ngIf'd out) so password managers still see
           the full username + password pair within this same <form> for autofill/save support. -->
      <ion-item class="login_fields " lines="none" [class.visually-hidden]="field.hidden"
        [attr.aria-hidden]="field.hidden ? true : null" [ngClass]="fieldValidation() ? 'fieldBorder' : 'accountBorder'">
        <!-- leading icon for input field -->
        @if (field.icon) {
        <span class="icon {{ field.icon }} input-icon"></span>
        <span class="sep"></span>
        }

        <!-- Form input bound to dynamic model -->
        <ion-input class="login_content" [ngClass]="{ margin: field.icon }"
          [type]="field.type === 'password' && showPassword() ? 'text' : field.type" [name]="field.name"
          [(ngModel)]="model()[field.name]" [autocomplete]="field.autocomplete" [tabindex]="field.hidden ? -1 : 0"
          [attr.aria-hidden]="field.hidden ? true : null" [placeholder]="field.placeholder | translate">
        </ion-input>

        <!-- Password visibility toggle -->
        @if (field.toggleVisibility) {
        <span class="input-icon eye-icon icon" role="button" [ngClass]="showPassword() ? 'icon-eye-close' : 'icon-view'"
          (click)="togglePassword.emit()" (keydown.enter)="togglePassword.emit()">
        </span>
        }
      </ion-item>

      <!-- Validation error placeholder -->
      @if (!field.hidden) {
      <small class="text-danger-accent">
        @for (validation of getUniqueValidations(field.validations); track $index) {
        {{validation}}
        <br>
        }
      </small>
      }
    </ng-container>
    }

    <!-- Form action buttons -->
    <div class="d-flex flex-column flex-md-row gap-2 mt-4">
      <!-- Optional back action -->
      @if (config()?.backLabel) {
      <ion-button expand="block" type="button" class="login-btn dark flex-fill font-lg" (click)="emitBack()"
        (keydown.enter)="emitBack()">
        <span>
          {{ config()?.backLabel | translate }}
        </span>
      </ion-button>
      }

      <!-- Primary submit action -->
      <ion-button expand="block" type="submit" class="btn_secondary flex-fill font-lg">
        <span class="pt-2 pb-2">
          {{ config()?.submitLabel | translate }}
        </span>
      </ion-button>
    </div>
  </form>
</ng-container>
